import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Alert,
  Button,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { useTranslation, withTranslation } from "react-i18next";
import { addFxWithdraw } from "../../../apis/withdraw";
import calculateFee from "../../../helpers/calculateTranFee";
import CardWrapper from "../../Common/CardWrapper";
import CustomModal from "../../Common/CustomModal";
import AddBankAccountModal from "../../BankAccounts/AddBankAccountModal";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AvFieldSelecvt from "components/Common/AvFieldSelect";
import {
  fetchProfile,
  getAccountsStart,
  toggleCurrentModal 
} from "store/actions";
import { getConversionRate } from "apis/conversionRate";
import { withdrawalConfig } from "../MT5/withdrawalConfig.js";
import { validateFile } from "helpers/validations/file";
import TransactionLimits from "components/Modals/Wallets/TransactionLimits";
import VerifyOTP from "components/Common/VerifyOTP";
import * as content from "content.js";

function Mt5Withdraw({ isOpen, toggleOpen : toggle, saddadShow = false, ...props }) { 
  const dispatch = useDispatch();
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [baseCurrency, setBaseCurrency] = useState("USD");
  const targetCurrency = selectedAccount?.currency || "USD";
  const [conversionRate, setConversionRate] = useState(1);
  const tranFeeGroupDetails = useSelector((state) => state.Profile?.clientData?.transactionFeeId);
  const { accounts } = useSelector(state=> state.forex.accounts);
  const { clientData } = useSelector(state=>state.Profile);
  const isKuwaitClient =
    typeof clientData?.country === "string" &&
    clientData.country.trim().toLowerCase() === "kuwait";
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [selectedWallet, setSelectedWallet] = useState("USD");
  const [amount, setAmount] = useState("");
  const [gateway, setGateway] = useState(""); 
  const [transactionFee, setTransactionFee] = useState("");
  const [result, setResult] = useState("");
  const [selectGatwayError, setSelectGatwayError] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  // used to check if amount is less than 15 then raise an error
  const [amountValidation, setAmountValidation] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [selectWalletError, setSelectWalletError] = useState(false);
  const [hoveredPaymentMethod, setHoveredPaymentMethod] = useState();
  const [addBankModal, setAddBankModal] = useState(false);
  const [bankAccount, setBankAccount] = useState({});
  const [isFirstStepValid, setIsFirstStepValid] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [collectorID, setCollectorID] = useState("");
  const [collectorNumber, setcollectorNumber] = useState("");
  const [collectorName, setCollectorName] = useState("");
  const isWeekend = ["Sat", "Sun"].includes(
    new Intl.DateTimeFormat("en-US", {
      timeZone: "Etc/GMT-2",
      weekday: "short"
    }).format(new Date())
  );
  
  const bankAccounts = useSelector(
    (state) => state.crypto.bankAccounts?.bankAccounts?.docs
  );
  const [isValid, setIsValid] = useState(false);
  const [methodConfig, setMethodConfig] = useState({});
  const { t } = useTranslation();
  useEffect(() => {
    if (isOpen) {
      setActiveStep(0);
      // setSelectedWallet(defaultFiatWallet?.value);
      setGateway("");
      setAmount("");
      setIsFirstStepValid(false);
    }
  }, [isOpen]);

  useEffect(() => {
    dispatch(getAccountsStart({
      limit: 500,
    }));
  }, []);

  function toggleTab(tab) {
    if (activeStep !== tab) {
      setActiveStep(tab);
    }
  }
  useEffect(() => {
    setTransactionFee(tranFeeGroupDetails ? calculateFee(tranFeeGroupDetails, amount) : 0);
  }, [tranFeeGroupDetails, amount]);
  

  useEffect(() => {
    if (targetCurrency !== baseCurrency){
      getConversionRate({
        baseCurrency,
        targetCurrency,
      }).then((res) => {
        setConversionRate(res);
      });
    }
  }, [baseCurrency, targetCurrency]);

  const handleSubmit = (e, v) => {
    if (isWeekend) {
      return;
    }
    // event.preventDefault();
    setLoading(true);
    addFxWithdraw({
      gateway: gateway,
      amount: amount,
      tradingAccountId:v.toAccount,
      note: "note",
      payload: methodConfig,
      collectorName: collectorName,
      collectorID: collectorID,
      collectorNumber: collectorName,
    })
      .then((e) => {
        // console.log(e);
        setResult(e);
        toggleTab(2);
      })
      .catch((e) => {
        // console.log(e);
        setResult(e);
        toggleTab(2);
      });
    // toggleOpen()
  };

  const validateStep1 = () => {
    if (isWeekend) {
      return;
    }
    if (selectedWallet === "") {
      setSelectWalletError(true);
      setTimeout(() => {
        setSelectWalletError(false);
      }, 2000);
    } 
    if (gateway === "") {
      setSelectGatwayError(true);
      setTimeout(() => {
        setSelectGatwayError(false);
      }, 2000);
    }
    if (gateway != "") {
      toggleTab(1);
    }
  };
  const validateStep2 = (e, v) => {
    if (isWeekend) {
      return;
    }
    if (loading) {
      return;
    }
    if (amount == "") {
      setAmountError(true);
      setTimeout(() => {
        setAmountError(false);
      }, 2000);
    } else {
      handleSubmit(e, v);
    }
  };


  const amountValidationHanlder = () => {
    amount < selectedAccount?.accountTypeId.minWithdrawal ? setAmountValidation(true) : setAmountValidation(false);
  };

  useEffect(() => {
    if (amount && selectedAccount) {
      amountValidationHanlder();
    }
  }, [amount, selectedAccount]);


  const isFirstSubmitValid = () => {
    if (gateway === "") {
      return setIsFirstStepValid(false);
    } else if (gateway === "WIRE_TRANSFER") {
      if (Object.keys(bankAccount).length === 0) {
        return setIsFirstStepValid(false);
      } else {
        return setIsFirstStepValid(true);
      }
    }
    else if (gateway === "CASH"){
      return setIsFirstStepValid(true); 
    } 
    else if (gateway === "SADAAD_PAY") {
      return setIsFirstStepValid(true); 
    }
    else if (gateway === "HESABE") {
      return setIsFirstStepValid(true); 
    }
    else if (gateway === "CRYPTO") {
      if (methodConfig?.network && methodConfig?.coin && methodConfig?.address !== "") {
        return setIsFirstStepValid(true);
      } else {
        return setIsFirstStepValid(false);
      }
    }
    return setIsFirstStepValid(false);
  };

  useEffect(() => {
    isFirstSubmitValid();
  }, [gateway, bankAccount, bankAccounts, methodConfig]);

  const toggleOpen = () => {
    dispatch(fetchProfile());
    toggle();
  };
  const steps = [
    {
      header: t("Select Method"),
      content: (
        <>
          <div className="my-4">
            <AvForm
              onValidSubmit={validateStep1}
            >
              {isWeekend && (
                <Alert color="warning" className="text-center mb-3">
                  {t("MT5 withdrawals are disabled on Saturdays and Sundays.")}
                </Alert>
              )}
              <div className="mb-4">
                <h6 className="mb-3">
                  {props.t("Select Withdrawal Method")}
                  {selectGatwayError && (
                    <p className="small text-danger ">
                      {props.t("Please Select Withdrawal Method")}
                    </p>
                  )}
                </h6>
                <Row className="justify-content-center payment-methods">
                  {
                    withdrawalConfig
                      .filter((method) =>
                        isKuwaitClient
                          ? method.gateway === "HESABE"
                          : true
                      )
                      .filter(method => method.allowed.mt5)
                      .map((method, index) => (
                        <Col xs={4} lg={2} className="my-2" key={index}>
                          <button
                            type="button"
                            onClick={() => {
                              setGateway(method.gateway);
                              setSelectedPaymentMethod(method.gateway);
                              setMethodConfig(method);
                            }}
                            onMouseEnter={() => {setHoveredPaymentMethod(method.gateway)}}
                            onMouseLeave={() => {setHoveredPaymentMethod()}}
                            className={`btn btn-${selectedPaymentMethod === method.gateway ? "success" : hoveredPaymentMethod === method.gateway ? "default" : "light"} waves-effect waves-light w-sm py-4`}
                            style={{
                              maxWidth: "80px",
                              maxHeight: "80px",
                            }}
                          >
                            <img
                              src={method.image}
                              // width="100%"
                              // height="100%"
                              alt=""
                            ></img>
                          </button>
                        </Col>
                      ))
                  }
                  {/* <Col xs={4} lg={2} className="my-2">
                    <button
                      type="button"
                      onClick={() => {
                        setGateway("VISA");
                        setSelectedPaymentMethod("VISA");
                      }}
                      onMouseEnter={() => {setHoveredPaymentMethod("VISA")}}
                      onMouseLeave={() => {setHoveredPaymentMethod()}}
                      className={`btn btn-${selectedPaymentMethod === "VISA" ? "success" : hoveredPaymentMethod === "VISA" ? "default" : "light"} waves-effect waves-light w-sm py-4`}
                    >
                      <img
                        src="/img/payment-method/visa.png"
                        width="100%"
                        height="100%"
                        alt=""
                      ></img>
                    </button>
                  </Col>
                  <Col xs={4} lg={2} className="my-2">
                    <button
                      type="button"
                      onClick={() => {
                        setGateway("MASTERCARD");
                        setSelectedPaymentMethod("MASTERCARD");
                      }}
                      onMouseEnter={() => {setHoveredPaymentMethod("MASTERCARD")}}
                      onMouseLeave={() => {setHoveredPaymentMethod()}}
                      className={`btn btn-${selectedPaymentMethod === "MASTERCARD" ? "success" : hoveredPaymentMethod === "MASTERCARD" ? "default" : "light"} waves-effect waves-light w-sm py-4`}
                    >
                      <img
                        src="/img/payment-method/mastercard-1.png"
                        width="100%"
                        height="100%"
                        alt=""
                      ></img>
                    </button>
                  </Col>
                  <Col xs={4} lg={2} className="my-2">
                    <button
                      type="button"
                      onClick={() => {
                        setGateway("NETELLER");
                        setSelectedPaymentMethod("NETELLER");
                      }}
                      onMouseEnter={() => {setHoveredPaymentMethod("NETELLER")}}
                      onMouseLeave={() => {setHoveredPaymentMethod()}}
                      className={`btn btn-${selectedPaymentMethod === "NETELLER" ? "success" : hoveredPaymentMethod === "NETELLER" ? "default" : "light"} waves-effect waves-light w-sm py-4`}
                    >
                      <img
                        src="/img/payment-method/neteller.png"
                        width="100%"
                        height="100%"
                        alt=""
                      ></img>
                    </button>
                  </Col>
                  <Col xs={4} lg={2} className="my-2">
                    <button
                      type="button"
                      onClick={() => {
                        setGateway("SKRILL");
                        setSelectedPaymentMethod("SKRILL");
                      }}
                      onMouseEnter={() => {setHoveredPaymentMethod("SKRILL")}}
                      onMouseLeave={() => {setHoveredPaymentMethod()}}
                      className={`btn btn-${selectedPaymentMethod === "SKRILL" ? "success" : hoveredPaymentMethod === "SKRILL" ? "default" : "light"} waves-effect waves-light w-sm py-4`}
                    >
                      <img
                        src="/img/payment-method/skrill.png"
                        width="100%"
                        height="100%"
                        alt=""
                      ></img>
                    </button>
                  </Col> */}
                </Row>
              </div>
              {gateway == "WIRE_TRANSFER" && (
                <div className="mb-3">
                  <Label>{props.t("Select Bank Account")}</Label>
                  <AvFieldSelecvt
                    name="bankAccount"
                    className="form-select"
                    onChange={(e) => {
                      setBankAccount(e);
                      setBaseCurrency(e?.currency);
                      setMethodConfig({
                        ...methodConfig,
                        bankAccount: e,
                      });
                      setIsFirstStepValid(true);
                    }}
                    required
                    placeholder={props.t("Select")}
                    options={bankAccounts?.map((bankAccount) => {
                      return {
                        label:`${bankAccount.bankName}`,
                        value: bankAccount
                      };
                    })}
                  >
                  </AvFieldSelecvt>
                  <InputGroup className="mt-2">
                    <InputGroupText className="custom-input-group-text">
                      <Link
                        to="#"
                        onClick={() => {
                          setAddBankModal(true);
                        }}
                      >
                        {props.t("Add New")}
                      </Link>
                    </InputGroupText>
                  </InputGroup>
                </div>
              )}
              {
                gateway === "CRYPTO" && selectedPaymentMethod && (
                  <>
                    <div className="mb-3">
                      <Label>{props.t("Select Network")}</Label>
                      <AvFieldSelecvt
                        name="cryptoNetwork"
                        className="form-select"
                        onChange={(e) => {
                          setMethodConfig({
                            ...methodConfig,
                            network: e,
                            coin: "",
                            address: "",
                          });
                          // setCryptoCurrency(e);
                        }}
                        options={methodConfig?.config.methods.map((method) => {
                          return {
                            label: method.network,
                            value: method,
                          };
                        })}
                      />
                    </div>
                    {
                      methodConfig?.network && (
                        <>
                          <div className="mb-3">
                            <Label>{props.t("Select Coin")}</Label>
                            <AvFieldSelecvt
                              name="cryptoCoin"
                              className="form-select"
                              onChange={(e) => {
                                setMethodConfig({
                                  ...methodConfig,
                                  coin: e,
                                  address: "",
                                });
                                // setCryptoCurrency(e);
                              }}
                              options={methodConfig?.network?.coins?.map((method) => {
                                return {
                                  label: method,
                                  value: method,
                                };
                              })}
                            />
                          </div>
                        </>
                      )
                    }
                    {
                      methodConfig?.coin && (
                        <>
                          <div className="mb-3">
                            <Label>{props.t("Select Address")}</Label>
                            <AvField
                              name="cryptoAddress"
                              className="form-control"
                              placeholder={props.t("Enter Address")}
                              value={methodConfig?.address}
                              onChange={(e) => {
                                setMethodConfig({
                                  ...methodConfig,
                                  address: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </>
                      )
                    }
                  </>
                )
              }
              
              {gateway === "CASH" && (
                <>
                  <div className="mb-3">
                    <AvField
                      name="collector"
                      label="Collecting Person Name"
                      type="tex+t"
                      onChange={(e) => {setCollectorName(e.target.value)}}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Please enter collecting person name"
                        },
                        pattern: {
                          value: /^[a-zA-Z\s]*$/,
                          errorMessage: "Only letters and spaces are allowed"
                        }
                      }}
                      
                    />
                  </div>
                  <div className="mb-3">
                    <AvField
                      name="id"
                      label="ID Number"
                      type="number"
                      onChange={(e) => {setCollectorID(e.target.value)}} 
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Please enter id number"
                        },
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <AvField
                      name="number"
                      label="Contact Number"
                      onChange={(e) => {setcollectorNumber(e.target.value)}}
                      type="number"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Please enter contact number"
                        },
                      }}
                    />
                  </div>
                </>
              )}
                
              {
                gateway === "صناديق-الاعتماد" && (
                  <>
                    <div className="mb-3">
                      <Label>{t("Type")}</Label>
                      <AvFieldSelecvt
                        name="sandoqType"
                        className="form-select"
                        placeholder="Select Type"
                        onChange={(e) => {
                          setMethodConfig({
                            ...methodConfig,
                            type: e,
                          });
                        }}
                        options={methodConfig?.config?.methods?.map((option) => {
                          return {
                            label: option?.title,
                            value: option?.title,
                          };
                        })}
                      />
                    </div>
                    {
                      methodConfig?.type && (
                        <>
                          {methodConfig.type === "حواله" && (
                            <>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="receipt">
                                  {t("Receipt")}
                                </Label>
                                <AvField
                                  type="file"
                                  name="receipt"
                                  className="form-control form-control-md"
                                  errorMessage={t("Receipt is required")}
                                  onChange={(e) => {
                                    setMethodConfig({
                                      ...methodConfig,
                                      file: e.target.files[0],
                                    });
                                  }}
                                  validate={{
                                    required: { value: true },
                                    validate: validateFile(["jpg", "jpeg", "png"], 1000000, (methodConfig?.file || {}), {
                                      sizeValidationMessage: t("The file size is too large"),
                                      extensionValidationMessage: t("The file extension is not allowed"),
                                    })
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <Label>{t("وجه الحواله")}</Label>
                                <AvField
                                  name="locationOfHawala"
                                  type="text"
                                  placeholder="وجه الحواله"
                                  onChange={(e) => {
                                    setMethodConfig({
                                      ...methodConfig,
                                      locationOfHawala: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </>
                          )} 
                          {methodConfig.type === "اعتماد" && (
                            <>
                              <div className="mb-3">
                                <Label>{t("اسم الصندوق")}</Label>
                                <AvField
                                  name="nameOfBox"
                                  type="text"
                                  placeholder="اسم الصندوق"
                                  onChange={(e) => {
                                    setMethodConfig({
                                      ...methodConfig,
                                      nameOfBox: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <Label>{t("رقم الصندوق")}</Label>
                                <AvField
                                  name="numberOfBox"
                                  type="text"
                                  placeholder="رقم الصندوق"
                                  onChange={(e) => {
                                    setMethodConfig({
                                      ...methodConfig,
                                      numberOfBox: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </>
                          )} 
                        </>
                      )
                    }
                  </>
                )
              }
              {(gateway === "WIRE_TRANSFER" && bankAccount && Object.keys(bankAccount).length > 0) ?
                (
                  <>
                    <AvForm>
                      <h5 className="mb-4">{props.t("Payment details")}</h5>
                      <div>
                        <Label>{props.t("Bank Holder Name")}</Label>
                        <AvField
                          type="text"
                          name="accountHolderName"
                          value={`${clientData?.firstName} ${clientData?.lastName}`}
                          validate={{ required:true }}
                          disabled={true}
                        >
                        </AvField>
                      </div>
                      <div>
                        <Label>{props.t("Bank Name")}</Label>
                        <AvField
                          type="text"
                          name="bankName"
                          value={bankAccount.bankName}
                          validate={{ required:true }}
                          disabled={true}
                        >
                        </AvField>
                      </div>
                      <div>
                        <Label>{props.t("Account Number")}</Label>
                        <AvField
                          type="text"
                          name="accountNumber"
                          value={bankAccount.accountNumber}
                          validate={{ required:true }}
                          disabled={true}
                        >
                        </AvField>
                      </div>
                      <div>
                        <Label>{props.t("Address")}</Label>
                        <AvField
                          type="text"
                          name="address"
                          value={bankAccount.address}
                          validate={{ required:true }}
                          disabled={true}
                        >
                        </AvField>
                      </div>
                      <div>
                        <Label>{props.t("Swift Code")}</Label>
                        <AvField
                          type="text"
                          name="swiftCode"
                          value={bankAccount.swiftCode}
                          validate={{ required:true }}
                          disabled={true}
                        >
                        </AvField>
                      </div>
                      <div>
                        <Label>{props.t("Currency")}</Label>
                        <AvField
                          type="text"
                          name="currency"
                          disabled={true}
                          value={bankAccount.currency}
                          validate={{ required:true }}
                        >
                        </AvField>
                      </div>
                      <p>{props.t("Bank Account")}</p>
                      {/* <p className="text-muted">
                        {props.t("You MUST include the Reference Code in your deposit in order to credit your account!")}
                      </p> */}
                    </AvForm>
                  </>  
                )  : gateway == "SKRILL" ||
                gateway == "NETELLER" ||
                gateway == "MASTERCARD" ? (
                    <>
                      <p className="text-muted">{props.t("")}{props.t("Enter card information.")}</p>
                      <Row>
                        <AvForm>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label
                                htmlFor="example-date-input"
                                className="form-label"
                              >
                                {props.t("Name")}
                              </Label>
                              <Input
                                className="form-control"
                                type="text"
                                id="example-date-input"
                              />
                            </div>
                          </Col>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label
                                htmlFor="example-date-input"
                                className="form-label"
                              >
                                {props.t("Card Number")}
                              </Label>
                              <Input
                                className="form-control"
                                type="text"
                                id="example-date-input"
                              />
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label
                                htmlFor="example-date-input"
                                className="form-label"
                              >
                                {props.t("Expiry date")}
                              </Label>
                              <Input
                                className="form-control"
                                type="date"
                                id="example-date-input"
                              />
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label
                                htmlFor="example-date-input"
                                className="form-label"
                              >
                                {props.t("Security Code (CVV)")}
                              </Label>
                              <Input
                                className="form-control"
                                type="text"
                                id="example-date-input"
                              />
                            </div>
                          </Col>
                        </AvForm>
                      </Row>
                    </>
                  ) : (
                    ""
                  )
              }
              {gateway === "WIRE_TRANSFER" && <Row>
                <Col xs={12} className="text-center py-2">
                  <h4>{props.t("Local Bank Deposit Terms & Conditions")}</h4>
                </Col>
                <Col xs={12} className="py-2">
                  <div>
                    <p> 1. {props.t("Withdrawals available Monday to Friday.")}</p>
                    <p> 2. {props.t("Initial deposit can only be withdrawn to the same bank account.")}</p>
                    <p> 3. {props.t("Double-check your account details before making the transaction.")}</p>
                    <p> 4. {props.t("Fill in your NAME/BANK NAME/BANK ACCOUNT/IFSC CODE/BANK ADDRESS in CAPITAL LETTERS only.")}</p>
                    <p> 5. {props.t("Ensure sufficient free margin in your account to cover the withdrawal. Close positions if needed.")}</p>
                    <p> 6. {props.t("Withdrawals processed within 24 hours. Funds posted to your bank account within 24-72 hours. Verification delays possible.")}</p>
                    <p>7. {props.t(`Check bank account details before withdrawing. ${content.clientName} not responsible for incorrect information.`)}</p>
                  </div>
                </Col>
              </Row>}
              {gateway === "CRYPTO" && selectedPaymentMethod && <Row>
                <Col xs={12} className="text-center py-2">
                  <h4>{props.t("Crypto Terms & Conditions")}</h4>
                </Col>
                <Col xs={12} className="py-2">
                  <div>
                    <p>1. {props.t("Clients can withdraw a minimum of 10 USDT.")}</p>
                    <p>2. {props.t("Withdrawal Depending on the Blockchain.")}</p>
                    <p>3. {props.t("Withdrawal will be allowed in the same mode as deposit is made.")}</p>
                    <p>4. {props.t("Use the wallet address that matches the selected network. Any withdrawal sent to an incompatible address may result in the loss of funds forever.")}</p>
                    <p>5. {props.t("At the time of withdrawal it is a sole responsibility of the client while providing the Wallet ID.")}</p>
                  </div>
                </Col>
              </Row>}
              <div className="text-center mt-4">
                <Button
                  type="submit"
                  className="btn btn-success waves-effect waves-light w-lg btn-sm"
                  disabled={isWeekend || !isFirstStepValid || !selectedPaymentMethod || (gateway === "CASH" && (!collectorName || !collectorID || !collectorNumber)) }
                >
                  {props.t("Continue")}
                </Button>
              </div>
            </AvForm>
          </div>
        </>
      ),
    },
    {
      header: "Enter Amount",
      content: (
        <>
          {
            <>
              <AvForm
                onValidSubmit={(e, v) => {
                  validateStep2(e, v);
                }}
              >
                {isWeekend && (
                  <Alert color="warning" className="text-center mb-3">
                    {t("MT5 withdrawals are disabled on Saturdays and Sundays.")}
                  </Alert>
                )}
                <h6 className="mb-3">{props.t("Enter Amount")}</h6>
                <div className="d-flex justify-content-between mb-2">
                  <div>
                    <Label htmlFor="example-date-input" className="form-label">
                      {props.t("Amount")}
                    </Label>
                  </div>
                  <div>
                    {props.t("Transaction requirements")}
                    <i className="fas fa-info-circle ms-2"></i>
                  </div>
                </div>
                <InputGroup>
                  <Input
                    required
                    onChange={(e) => {
                      setAmount(e.target.value);
                    }}
                    className="form-control"
                    type="number"
                    min="0"
                    value={amount}
                    placeholder="Enter 15-128341"
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {/* <InputGroupText className="custom-input-group-text p-0 border-0">
                    <div style={{
                      width: "127px",
                    }}
                    >
                      <AvFieldSelect
                        style={{ height:"100%" }}
                        name="wallets"
                        options={[{
                          label:"USD",
                          value:"USD"
                        }]}
                        defaultValue={"USD"}
                        onChange={(e) => {
                          setSelectedWallet(e);
                        }}
                      >
                      </AvFieldSelect>
                    </div>
                  </InputGroupText> */}
                </InputGroup>
                {amountValidation && (
                  <p className="small text-danger "> {props.t("The minimum withdrawal amount value for this account is") + " " + selectedAccount?.accountTypeId?.minWithdrawal + " " + selectedAccount?.currency}</p>
                )}
                {amountError && (
                  <p className="small text-danger "> {props.t("Please Enter Amount")}</p>
                )}
                <div className="mt-3">
                  <AvFieldSelecvt
                    options={
                      accounts?.filter(a => !["DEMO", "IB"].includes(a.type))?.filter(a => a.profile ? a.profile?.profileType === 9 : true)?.map(acc=>{
                        return {
                          label:`${acc?.login} ${acc?.accountTypeId?.title} (${acc?.Balance} ${acc?.currency})`,
                          value: acc?._id,
                          disabled: acc.withdrawalDisabled ?? false
                        };
                      })
                    }
                    onChange={(e) => setSelectedAccount(accounts.find((acc) => acc._id === e))}
                    name="toAccount"
                    type="text"
                    errorMessage={props.t("Account is required")}
                    validate={{ required: { value: true } }}
                    label={props.t("MT5 Account")}
                  >
                  </AvFieldSelecvt>
                </div>
                {
                  baseCurrency !== targetCurrency && conversionRate !== 0 && selectedAccount &&
                    <p className=" ">{props.t("Note: Conversion rate of ")}{amount} {selectedWallet} = { (conversionRate * amount).toFixed(2)} {targetCurrency}</p>
                }
                <div className="text-center fw-bolder mt-4 received-amount">
                  <span className="fs-1">{amount}</span>
                  <span className="fs-5 mx-2">{selectedWallet || selectedWallet.label}</span>
                </div>
                {/* <div className="text-center mb-4">You receive:</div> */}
                <div className="mb-3">
                  <Label className="form-label mb-2">{props.t("Transaction Fee")}</Label>
                  <InputGroup className="">
                    <InputGroupText className=" w-100">
                      {transactionFee}{"   "}{selectedWallet?.label}
                    </InputGroupText>
                    {/* <Input className="form-control border-start-0 text-end" type="text" placeholder="0.00 EUR" /> */}
                  </InputGroup>
                </div>
                <div>
                  <TransactionLimits
                    amt={amount}
                    baseCurrency={"USD"}
                    setIsValid={setIsValid}
                    isFromSelected={true}
                    isFx={true}
                    isInternalTransfer={false}
                  />
                </div>
                {/* {
                  !isOTPVerified &&  <VerifyOTP
                    isOTPVerified={isOTPVerified}
                    setIsOTPVerified={setIsOTPVerified}
                  />
                } */}
                <div className="my-4 text-center">
                  <Button
                    className="btn btn-primary m-2 btn-sm w-lg"
                    onClick={() => {                      
                      toggleTab(0);
                      setBankAccount({});
                      setIsFirstStepValid(false);
                      setMethodConfig({
                        ...methodConfig,
                        coin: "",
                        address: "",
                        network: ""
                      });
                      setCollectorID("");
                      setcollectorNumber("");
                      setCollectorName("");
                    }}
                  >
                    {props.t("Back")}
                  </Button>
                  <Button
                    className="btn btn-success m-2 btn-sm w-lg"
                    type="submit"
                    disabled={isWeekend || loading || amountValidation || !isValid}
                  >
                    {props.t("Continue")}
                  </Button>
                </div>
              </AvForm>
            </>
          }
        </>
      ),
    },
    {
      header: "Withdraw status",
      content: (
        <>
          {result?.isSuccess ? (
            <>
              <div className="text-center  mb-4">
                <h1 className="fs-1 mb-5">
                  {props.t("Yay!")} <i className="bx bx-wink-smile"></i>
                </h1>
                <p>{props.t("Pending Withdraw Thank You")}</p>
                <p>
                  <span className="positive">
                    {result?.result?.amount || result?.result?.amount["$numberDecimal"]}
                  </span>
                  <span className="positive mx-2">
                    {selectedWallet || selectedWallet.label}
                  </span>
                </p>
              </div>
              <CardWrapper className="mb-4">
                <div className="d-flex align-items-center justify-content-around px-4">
                  <div>
                    <div className="text-muted">{props.t("Status")}</div>
                    <div className="positive">{props.t("gateway")}</div>
                  </div>
                  <div>
                    <div className="text-muted">{result.result?.status}</div>
                    <div>{result.result?.gateway}</div>
                  </div>
                </div>
              </CardWrapper> 
            </>
          ) : (
            <>
              <div className="text-center  mb-4">
                <h1 className="fs-1 mb-5">
                  {props.t("Oops!")} <i className="bx sad"></i>
                </h1>
                <p>{props.t("Your Withdraw Request Not Successfully Created")}</p>
              </div>
              <CardWrapper className="mb-4">
                <div className="d-flex align-items-center justify-content-between px-5">
                  <div>
                    <div className="positive">{result?.message}</div>
                  </div>
                </div>
              </CardWrapper>
            </>
          )}
          <div className="text-center">
            <Button
              className="btn btn-danger m-2 btn-sm w-lg"
              onClick={toggleOpen}
            >
              {props.t("Continue")}
            </Button>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <CustomModal
        steps={steps}
        isOpen={isOpen}
        toggleOpen={toggleOpen}
        activeStep={activeStep}
        toggleTab={toggleTab}
      ></CustomModal> 
      <AddBankAccountModal
        isOpen={addBankModal}
        toggleOpen={() => {
          setAddBankModal(false);
        }}
      ></AddBankAccountModal>
    </>

  );
}
export default withTranslation()(Mt5Withdraw); 
